export enum FlowNodeInputTypeEnum {
  systemInput = "systemInput", // history, userChatInput, variableInput

  input = "input", // one line input
  numberInput = "numberInput",
  select = "select",
  selectWxUser = "selectWxUser",
  slider = "slider",
  target = "target", // data input
  switch = "switch",
  selectAiModel = "selectAiModel",

  cascader = "cascader",

  // editor
  textarea = "textarea",

  addInputParam = "addInputParam", // params input

  // selectApp = "selectApp", // AI机器人嵌入，选择AI机器人

  // chat special input
  aiSettings = "aiSettings",

  // ai model select
  selectLLMModel = "selectLLMModel",

  // dataset special input
  selectedKnowledgeBase = "selectKnowledgeBase",
  selectedAdvanceKnowledge = "selectedAdvanceKnowledge",
  selectedSmartKnowledge = "selectedSmartKnowledge",
  selectedKnowledgeAll = "selectedKnowledgeAll",

  hidden = "hidden",

  addKv = "addKv",
  custom = "custom",

  // 素材库选择
  selectedMaterial = "selectedMaterial",

  // 条件输入
  conditionInput = "conditionInput",

  // 机器人选择名称， XF-1234 需求
  selectAppName = "selectAppName",

  // 素材库上传文件
  uploadMaterial = "uploadMaterial",

  selectDamselfishTags = "selectDamselfishTags",

  // 选择MCP
  selectMcp = "selectMcp",
}

export enum FlowNodeOutputTypeEnum {
  source = "source",
  hidden = "hidden",

  addOutputParam = "addOutputParam",
}

export enum FlowNodeTypeEnum {
  globalVariable = "globalVariable",
  userChatInput = "userChatInput",
  aiChat = "aiChat",
  delay = "delay",
  chatHistory = "chatHistory",
  tfJudge = "tfJudge",

  knowledgeBase = "knowledgeBase",
  knowledgeConcat = "knowledgeConcat",

  assignedAnswerNode = "assignedAnswerNode",
  classifyQuestion = "classifyQuestion",
  contentExtract = "contentExtract",
  jsonContentExtract = "jsonContentExtract",
  regexpContentExtract = "regexpContentExtract",
  contentProcess = "contentProcess",
  httpRequest = "httpRequest",
  runApp = "app",
  /** 调用AI机器人 */
  invokeApp = "invokeApp",
  /** 调用子流程模块 */
  pluginModule = "pluginModule", // 子流程模块
  pluginInput = "pluginInput", // 子流程输入
  pluginOutput = "pluginOutput", // 子流程输出
  queryExtension = "queryExtension",

  tools = "tools",
  messageOutput = "messageOutput",
  imageOutput = "imageOutput",
  videoOutput = "videoOutput",
  fileOutput = "fileOutput",
  cardOutput = "cardOutput",
  voiceOutput = "voiceOutput",
  markdownOutput = "markdownOutput", // markdown 输出

  setChatAttributes = "setChatAttributes",
  getChatAttributes = "getChatAttributes",

  getWxWorkTag = "getWxWorkTag",
  setWxWorkTag = "setWxWorkTag",

  // 12Times 标签
  getDamselfishTag = "getDamselfishTag",
  setDamselfishTag = "setDamselfishTag",
  deleteDamselfishTag = "deleteDamselfishTag",

  // 12Times群标签
  getDamselfishRoomTag = "getDamselfishRoomTag",
  setDamselfishRoomTag = "setDamselfishRoomTag",
  deleteDamselfishRoomTag = "deleteDamselfishRoomTag",

  cancelFlow = "cancelFlow",
  pullGroup = "pullGroup",
  // abandon

  // 新的判断器
  casesSwitcher = "casesSwitcher",

  // 高级知识库
  advancedKnowledgeBase = "advancedKnowledgeBase",
  // 模板参数
  templateParam = "templateParam",

  // 智能知识库
  smartKnowledgeBase = "smartKnowledgeBase",
  // 脚本运行
  codeRunner = "codeRunner",
  // rpa
  rpaRequest = "rpaRequest",

  // XF-1247 改版的知识库产品类型
  normalQuestionsKnowledgeBase = "normalQuestionsKnowledgeBase", // 常见问题知识库
  correctionKnowledgeBase = "correctionKnowledgeBase", // 纠偏知识库
  knowledgeCenterSearch = "knowledgeCenterSearch", // 知识中心搜索

  // 转译节点
  escapeText = "escapeText",

  // 邮件输出
  mailOutput = "mailOutput",
}

export const EDGE_TYPE = "default";
